'use client'
import {useTranslations} from "next-intl";
import {Flex, Typography, Row, Col, Layout} from "antd";
import {Content, Footer, Header} from "antd/lib/layout/layout";
import React, {useEffect, useState} from "react";
import FooterComponent from "@/src/app/[locale]/home/components/footer";
import '@/src/app/[locale]/home/home.css';
import PrivacyHeaderComponent from "@/src/app/[locale]/privacy/components/header";
import SanitazeHTML from "@/src/components/sanitazeHTML";
import './privacy.css';
import {inter} from "@/src/app/fonts";
import {Constants} from "@/src/lib/constants";

const PrivacyPage = () => {
    const localization = useTranslations('privacyAndCookies');
    const [isLoading, setIsLoading] = useState<boolean>(true)

    useEffect(() => {
        setIsLoading(false)
    }, []);

    const colors = {
        primary: "#A92216",
        secondary: "#EA2333",
        // tertiary: "#F6DB63"
        tertiary: "#FFFFFF"
    }

    const getPrivacyText = () => {
        const txt: string = localization.raw("privacy.text")
            .replace("_privacy_owner_text", `
             <p class="privacy"><b class="privacy">${Constants.privacyManagerName}</b></p>
            <p class="privacy">${Constants.privacyManagerAddressRow1}</p>
            <p class="privacy">${Constants.privacyManagerAddressRow2}</p>
            <p class="privacy"><b class="privacy">${localization("privacy.owner.mobile")}: </b>${Constants.privacyManagerPhone}</p>
            <p class="privacy"><b class="privacy">${localization("privacy.owner.email")}: </b>${Constants.privacyManagerEmail}</p>
            <p class="privacy"><b class="privacy">${localization("privacy.owner.vat")}: </b>${Constants.privacyManagerVat}</p>
        `)
        return txt
    }

    return (
        <>
            {(() => {
                if (isLoading) {
                    return <></>
                } else {
                    return <Layout>
                        <Header style={{height: "auto",backgroundColor: colors.tertiary }}>
                            <PrivacyHeaderComponent />
                        </Header>
                        <Content style={{ padding: "0 16px 48px 16px", backgroundColor: `${colors.tertiary}` }}>
                            <Row gutter={16}>
                                <Col>
                                    <Flex vertical gap={16} className={inter.className}>
                                        <Typography.Title level={3}>{localization("privacy.title")}</Typography.Title>
                                        <SanitazeHTML html={getPrivacyText()} options={{ALLOWED_TAGS: ["p", "h1", "h2", "ul", "li", "b", "privacyOwner"], ALLOWED_ATTR: ["class"]}}></SanitazeHTML>
                                    </Flex>
                                </Col>
                            </Row>

                            <Row gutter={16}>
                                <Col>
                                    <Flex vertical gap={16} className={inter.className}>
                                        <Typography.Title level={3}>{localization("cookies.title")}</Typography.Title>
                                        <SanitazeHTML html={localization.raw("cookies.text")} options={{ALLOWED_TAGS: ["p", "h1", "h2", "ul", "li", "b"], ALLOWED_ATTR: ["class"]}}></SanitazeHTML>
                                    </Flex>
                                </Col>
                            </Row>

                        </Content>
                        <Footer id="colophon" style={{ textAlign: 'center', backgroundColor: colors.primary, color: colors.tertiary, padding: "24px 0" }}>
                            <FooterComponent />
                        </Footer>
                    </Layout>
                }
            })()}
        </>
    )
}

export default PrivacyPage